import { useContext } from "react";

import { Grid } from "@mui/material";
import { AppContext } from "App";

import ArcCoCombinedContent from "./ArcCoCombinedContent";
import ArcCoRightPanel from "./ArcCoRightPanel";
import ArcCoStepsContent from "./ArcCoStepsContent";

export const ArcCoContent = ({ tabs, selectedTab, arcCoCalculations, combinedCalculation }) => {
  const {
    globalState: { isMenuOpen },
  } = useContext(AppContext);

  return (
    <div className="arc-co-content-grid">
      {tabs.map((tab, idx) => {
        return (
          <div
            key={tab.key}
            className="arc-co-tab-content"
            style={{ marginBottom: "2rem", display: idx === selectedTab ? "block" : "none" }}
          >
            <h3
              style={{
                display: "none",
              }}
            >
              {tab.label}
            </h3>
            <Grid
              container
              spacing={2}
              sx={{
                flexDirection: { xs: "column-reverse", lg: isMenuOpen ? "column-reverse" : "row", xl: "row" },
              }}
            >
              {tab.key === "combined" ? (
                <Grid item xs={12}>
                  <ArcCoCombinedContent
                    arcCoCalculations={arcCoCalculations}
                    combinedCalculation={combinedCalculation}
                  />
                </Grid>
              ) : (
                <>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={isMenuOpen ? 12 : 7}
                    xl={isMenuOpen ? 7 : 8}
                    className="arc-plc-steps-content"
                  >
                    <ArcCoStepsContent arcCoCalculation={tab.calc} combinedCalculation={combinedCalculation} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={isMenuOpen ? 12 : 5}
                    xl={isMenuOpen ? 5 : 4}
                    className="arc-co-right-panel"
                  >
                    <ArcCoRightPanel arcCoCalculation={tab.calc} practiceType={tab.key} />
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        );
      })}
    </div>
  );
};
